import { Box } from '@wix/design-system';
import React, { FunctionComponent, useCallback } from 'react';

import { LanguageSupportedNotification } from './LanguageSupportedNotification';
import { StatusPageNotification } from './StatusPageNotification';
import { PageType } from '../../types';

import css from './index.module.scss';

type NotificationBarProps = {
  pageType: PageType;
};

export const NotificationBar: FunctionComponent<NotificationBarProps> = ({
  pageType,
}) => {
  const updateBodyClass = useCallback((isVisible: boolean) => {
    if (document.body) {
      if (isVisible) {
        document.body.classList.add('notification-bar-visible');
      } else {
        document.body.classList.remove('notification-bar-visible');
      }
    }
  }, []);

  const onNotificationVisibilityChange = useCallback(
    (isVisible: boolean) => {
      updateBodyClass(isVisible);
    },
    [updateBodyClass]
  );

  return (
    <Box className={css.notificationBar} direction="vertical">
      {pageType !== PageType.RoadMap && (
        <LanguageSupportedNotification
          pageType={pageType}
          onVisibilityChange={onNotificationVisibilityChange}
        />
      )}
      <StatusPageNotification pageType={pageType} />
    </Box>
  );
};
